import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function ForbiddenPage() {
  return (
    <>
      <Helmet>
        <title>403 - Ingen adgang | POVL MØLLERS MASKINFABRIK A/S</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-stone-50 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-100 text-red-700 mb-6">
            <span className="text-3xl font-extrabold">403</span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
            Adgang nægtet
          </h1>
          <p className="mt-4 text-stone-600 text-sm sm:text-base leading-relaxed">
            Du har ikke tilladelse til at tilgå denne ressource. Hvis du mener dette er en fejl, er du velkommen til at kontakte os.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="px-6 py-3 rounded bg-[#006368] hover:bg-[#004d51] text-white font-semibold text-sm transition shadow-sm"
            >
              Tilbage til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="px-6 py-3 rounded border border-stone-300 bg-white hover:bg-stone-100 text-stone-800 font-semibold text-sm transition"
            >
              Kontakt support
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
